import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import httpClient from "../utils/httpClients";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Parallax, Pagination } from "swiper";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/parallax";
import "swiper/css/pagination";

const formatDuration = (seconds) => {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins}:${secs < 10 ? "0" : ""}${secs}`;
};

function Home() {
  const navigate = useNavigate();
  const sliderresRef = useRef(null);
  const slidergenRef = useRef(null);

  const [genres, setGenres] = useState([]);
  const [loadingGenres, setLoadingGenres] = useState(true);
  const [error, setError] = useState(null);
  const [banners, setBanners] = useState([]);
  const [popularPodcasts, setPopularPodcasts] = useState([]);
  const [featuredPodcasts, setFeaturedPodcasts] = useState([]);
  const [loadingPopular, setLoadingPopular] = useState(false);
  const [loadingFeatured, setLoadingFeatured] = useState(false);
  const [isMobileView, setIsMobileView] = useState(
    typeof window !== "undefined" ? window.innerWidth <= 768 : false,
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // NAVIGATE ONLY — playback starts when user clicks Play on the destination page
  const playPodcastAndNavigate = (podcast, source) => {
    const podcastId = podcast._id;
    const navState =
      source === "track"
        ? { trackData: podcast, source }
        : { source };

    navigate(`/podcast-episode/${podcastId}/${source}`, { state: navState });
  };

  useEffect(() => {
    fetchNewRelease();
    fetchFeaturedPodcasts();
    fetchGenres();
    fetchBanners();
  }, []);

  const settings = {
    slidesToShow: isMobileView ? 2 : 5,
    slidesToScroll: 1,
    infinite: true,
    arrows: false,
    dots: false,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 3 } },
      { breakpoint: 992, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 576, settings: { slidesToShow: 2 } },
    ],
  };

  const settingss = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: isMobileView ? 2 : 8,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 4 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 576, settings: { slidesToShow: 2 } },
    ],
  };

  const fetchGenres = async () => {
    try {
      setLoadingGenres(true);
      const res = await httpClient.get(`/user/home/home-page?type=genres`, {
        skipToast: true,
      });
      if (res.data && res.data.success) {
        setGenres(res.data.data || []);
      }
    } catch (err) {
      setError("Error loading genres.");
    } finally {
      setLoadingGenres(false);
    }
  };

  const fetchNewRelease = async () => {
    try {
      setLoadingPopular(true);
      const res = await httpClient.get(`/user/home/home-page?type=newRelease`, {
        skipToast: true,
      });
      if (res.data && res.data.success) {
        setPopularPodcasts(res.data.data || []);
      }
    } catch (err) {
      setError("Error fetching new releases");
    } finally {
      setLoadingPopular(false);
    }
  };

  const fetchFeaturedPodcasts = async () => {
    try {
      setLoadingFeatured(true);
      const res = await httpClient.get(`/user/home/home-page?type=featured`, {
        skipToast: true,
      });
      if (res.data && res.data.success) {
        setFeaturedPodcasts(res.data.data || []);
      }
    } catch (err) {
      setError("Error fetching featured podcasts");
    } finally {
      setLoadingFeatured(false);
    }
  };

  const fetchBanners = async () => {
    try {
      const response = await httpClient.get("admin/banner/all-banners", {
        skipToast: true,
      });
      setBanners(response.data.data.banners || []);
    } catch (error) {
      console.error("Error fetching banners:", error);
    }
  };

  const splitIntoColumns = (data, columns = 4) => {
    const result = [];
    const itemsPerColumn = Math.ceil(data.length / columns);
    for (let i = 0; i < columns; i++) {
      result.push(data.slice(i * itemsPerColumn, (i + 1) * itemsPerColumn));
    }
    return result;
  };

  const featuredColumns = splitIntoColumns(featuredPodcasts);

  // UPDATED: New Release Card with Queue + Navigate
  const NewReleaseCard = ({ podcast }) => (
    <div className="card card-slide mb-3 px-2 card-custom">
      <div className="album">
        <div
          className="album__cover position-relative"
          style={{ cursor: "pointer" }}
          onClick={() => playPodcastAndNavigate(podcast, podcast.__source)}
        >
          <img
            src={
              podcast.coverImageUrl?.trim()
                ? podcast.coverImageUrl
                : `${process.env.PUBLIC_URL}/assets/images/artist1.jpg`
            }
            alt={podcast.title}
            style={{ width: "100%", height: "160px", objectFit: "cover" }}
          />
          <div
            className="position-absolute inset-0 d-flex align-items-center justify-content-center opacity-0 hover-overlay"
            style={{
              background: "rgba(0,0,0,0.6)",
              transition: "all 0.3s ease",
              borderRadius: "8px",
            }}
          >
            <i
              className="fas fa-play text-white"
              style={{ fontSize: "40px" }}
            ></i>
          </div>
          <span className="album__stat">
            {/* <span>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path d="M3.71,16.29a1,1,0,0,0-.33-.21,1,1,0,0,0-.76,0,1,1,0,0,0-.33.21,1,1,0,0,0-.21.33,1,1,0,0,0,.21,1.09,1.15,1.15,0,0,0,.33.21.94.94,0,0,0,.76,0,1.15,1.15,0,0,0,.33-.21,1,1,0,0,0,.21-1.09A1,1,0,0,0,3.71,16.29ZM7,8H21a1,1,0,0,0,0-2H7A1,1,0,0,0,7,8ZM3.71,11.29a1,1,0,0,0-1.09-.21,1.15,1.15,0,0,0-.33.21,1,1,0,0,0-.21.33.94.94,0,0,0,0,.76,1.15,1.15,0,0,0,.21.33,1.15,1.15,0,0,0,.33.21.94.94,0,0,0,.76,0,1.15,1.15,0,0,0,.33-.21,1.15,1.15,0,0,0,.21-.33.94.94,0,0,0,0-.76A1,1,0,0,0,3.71,11.29ZM21,11H7a1,1,0,0,0,0,2H21a1,1,0,0,0,0-2ZM3.71,6.29a1,1,0,0,0-.33-.21,1,1,0,0,0-1.09.21,1.15,1.15,0,0,0-.21.33.94.94,0,0,0,0,.76,1.15,1.15,0,0,0,.21.33,1.15,1.15,0,0,0,.33.21,1,1,0,0,0,1.09-.21,1.15,1.15,0,0,0,.21-.33.94.94,0,0,0,0-.76A1.15,1.15,0,0,0,3.71,6.29ZM21,16H7a1,1,0,0,0,0,2H21a1,1,0,0,0,0-2Z" />
              </svg>
              {formatDuration(podcast.duration)}
            </span> */}
            <span>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path d="M20,13.18V11A8,8,0,0,0,4,11v2.18A3,3,0,0,0,2,16v2a3,3,0,0,0,3,3H8a1,1,0,0,0,1-1V14a1,1,0,0,0-1-1H6V11a6,6,0,0,1,12,0v2H16a1,1,0,0,0-1,1v6a1,1,0,0,0,1,1h3a3,3,0,0,0,3-3V16A3,3,0,0,0,20,13.18ZM7,15v4H5a1,1,0,0,1-1-1V16a1,1,0,0,1,1-1Zm13,3a1,1,0,0,1-1,1H17V15h2a1,1,0,0,1,1,1Z" />
              </svg>
              {podcast.playCount.toLocaleString()}
            </span>
          </span>
        </div>
        <div className="album__title">
          <h3>
            <Link
              to={`/podcast-episode/${podcast._id}/${podcast.__source}`}
              className="text-black"
              state={
                podcast?.__source === "track"
                  ? { trackData: podcast, source: podcast.__source }
                  : undefined
              }
            >
              {podcast.title}
            </Link>
          </h3>
          <span>
            <Link to={`/artist/${podcast.artistId || ""}`}>
              {podcast.artist || "Unknown Artist"}
            </Link>
          </span>
        </div>
      </div>
    </div>
  );

  // UPDATED: Featured Item with Queue + Navigate
  const FeaturedPodcastItem = ({ podcast, index, totalCount }) => (
    <li
      className={`${index < totalCount - 1 ? "border-bottom" : ""} py-3 single-item`}
    >
      <div className="d-flex ">
        <div
          className="single-item__cover me-3 position-relative"
          style={{ cursor: "pointer" }}
          onClick={() =>
            playPodcastAndNavigate(podcast, podcast.__source || "podcast")
          }
        >
          <img
            src={podcast.coverImageUrl}
            className="img-fluid avatar-55"
            alt={podcast.title}
            style={{ width: "55px", height: "55px", objectFit: "cover" }}
          />
          <div
            className="position-absolute inset-0 d-flex align-items-center justify-content-center opacity-0 hover-overlay"
            style={{
              background: "rgba(0,0,0,0.6)",
              transition: "all 0.3s ease",
              borderRadius: "8px",
            }}
          >
            <i
              className="fas fa-play text-white"
              style={{ fontSize: "20px" }}
            ></i>
          </div>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="M18.54,9,8.88,3.46a3.42,3.42,0,0,0-5.13,3V17.58A3.42,3.42,0,0,0,7.17,21a3.43,3.43,0,0,0,1.71-.46L18.54,15a3.42,3.42,0,0,0,0-5.92Zm-1,4.19L7.88,18.81a1.44,1.44,0,0,1-1.42,0,1.42,1.42,0,0,1-.71-1.23V6.42a1.42,1.42,0,0,1,.71-1.23A1.51,1.51,0,0,1,7.17,5a1.54,1.54,0,0,1,.71.19l9.66,5.58a1.42,1.42,0,0,1,0,2.46Z" />
          </svg>
        </div>
        <div className="d-flex align-items-center justify-content-between w-100">
          <div>
            <div>
              <Link
                to={`/podcast-episode/${podcast._id}/${podcast.__source || "podcast"}`}
                className="text-capitalize h5 d-block"
                style={{ fontSize: "1rem", fontWeight: "bold" }}
                state={
                  podcast?.__source === "track"
                    ? { trackData: podcast, source: podcast.__source }
                    : undefined
                }
              >
                {podcast.title.length > 10
                  ? podcast.title.slice(0, 10) + "..."
                  : podcast.title}
              </Link>
            </div>
            <small className="text-capitalize">{podcast.artist}</small>
            <br />
            {/* <small className="text-muted">
              {formatDuration(podcast.duration)}
            </small> */}
          </div>
          <div className="d-flex align-items-center heading-color">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={20}
              height={20}
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M15.7727 4.89531C15.025 4.14014 14.1357 3.53986 13.1558 3.12883C12.1758 2.71781 11.1244 2.50412 10.0617 2.5H10C7.84512 2.5 5.77849 3.35602 4.25476 4.87976C2.73102 6.40349 1.875 8.47012 1.875 10.625V15C1.875 15.4973 2.07254 15.9742 2.42417 16.3258C2.77581 16.6775 3.25272 16.875 3.75 16.875H5C5.49728 16.875 5.97419 16.6775 6.32583 16.3258C6.67746 15.9742 6.875 15.4973 6.875 15V11.875C6.875 11.3777 6.67746 10.9008 6.32583 10.5492C5.97419 10.1975 5.49728 10 5 10H3.15313C3.30905 8.29188 4.09785 6.70373 5.36466 5.54736C6.63147 4.39099 8.28477 3.74991 10 3.75H10.0523C11.7604 3.75722 13.4042 4.40211 14.6616 5.55827C15.9189 6.71444 16.6991 8.29851 16.8492 10H15C14.5027 10 14.0258 10.1975 13.6742 10.5492C13.3225 10.9008 13.125 11.3777 13.125 11.875V15C13.125 15.4973 13.3225 15.9742 13.6742 16.3258C14.0258 16.6775 14.5027 16.875 15 16.875H16.25C16.7473 16.875 17.2242 16.6775 17.5758 16.3258C17.9275 15.9742 18.125 15.4973 18.125 15V10.625C18.1291 9.56217 17.9234 8.50898 17.5197 7.52577C17.1161 6.54257 16.5224 5.64868 15.7727 4.89531ZM5 11.25C5.16576 11.25 5.32473 11.3158 5.44194 11.4331C5.55915 11.5503 5.625 11.7092 5.625 11.875V15C5.625 15.1658 5.55915 15.3247 5.44194 15.4419C5.32473 15.5592 5.16576 15.625 5 15.625H3.75C3.58424 15.625 3.42527 15.5592 3.30806 15.4419C3.19085 15.3247 3.125 15.1658 3.125 15V11.25H5ZM16.875 15C16.875 15.1658 16.8092 15.3247 16.6919 15.4419C16.5747 15.5592 16.4158 15.625 16.25 15.625H15C14.8342 15.625 14.6753 15.5592 14.5581 15.4419C14.4408 15.3247 14.375 15.1658 14.375 15V11.875C14.375 11.7092 14.4408 11.5503 14.5581 11.4331C14.6753 11.3158 14.8342 11.25 15 11.25H16.875V15Z"
                fill="#4A525F"
              />
            </svg>
            <small className="ms-2">{podcast.playCount.toLocaleString()}</small>
          </div>
        </div>
      </div>
    </li>
  );

  return (
    <div className="content-inner pb-0 container-fluid" id="page_layout">
      <div className="row mb-5">
        <div className="col-lg-12">
          <div className="card-header">
            <div className="">
              <h6 className="text-center mb-3">ADS</h6>
              <div className="add-image" />
            </div>

            {/* Banner Swiper */}
            <div className="col-lg-12 px-0">
              <div className="card-header">
                <div className="header-title">
                  <h2 className="card-title text-capitalize mb-3">
                    Explore New Music
                  </h2>
                </div>
                {/* <div className="bdt-timeline-container">
                  <div className="upk-salf-slider-wrapper">
                    <Swiper modules={[Autoplay, Parallax]} direction="vertical" speed={1200} parallax={true} autoplay={{ delay: 2500 }} loop={true} className="swiper-container mySwiper2 swiper-container-vertical" style={{ height: "400px" }}>
                      {banners.map((slide) => (
                        <SwiperSlide key={slide.id}>
                          <div className="upk-salf-item" style={{ height: "400px" }}>
                            <div className="upk-salf-image-wrap">
                              <img className="upk-xanc-img" src={slide.bannerUrl} alt={slide.title} />
                            </div>
                            <div className="upk-salf-content-wrap">
                              <h3 className="upk-salf-title" data-swiper-parallax-y="-150" data-swiper-parallax-duration="1200">
                                {slide.title}
                              </h3>
                              <div className="upk-salf-desc" data-swiper-parallax-y="-200" data-swiper-parallax-duration="1400">
                                {slide.description}
                              </div>
                            </div>
                          </div>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  </div>
                </div> */}
                <div className="bdt-timeline-container">
                  <div className="upk-salf-slider-wrapper">
                    <Swiper
                      modules={[Autoplay, Parallax, Pagination]}
                      speed={1200}
                      parallax={true}
                      autoplay={{
                        delay: 2500,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: false,
                      }}
                      loop={true}
                      pagination={{ clickable: true }}
                      className="swiper-container mySwiper2" // vertical class hata di
                      style={{ height: "400px" }}
                    >
                      {banners.map((slide) => (
                        <SwiperSlide key={slide.id} className="upk-salf-item">
                          <div
                            className="upk-salf-image-wrap"
                            style={{ overflow: "hidden", borderRadius: "10px" }}
                          >
                            <img
                              className="upk-xanc-img"
                              src={slide.bannerUrl}
                              alt={slide.title}
                            />
                          </div>
                          <div className="upk-salf-content-wrap">
                            <h3
                              className="upk-salf-title"
                              data-swiper-parallax-y="-150"
                              data-swiper-parallax-duration="1200"
                            >
                              {slide.title}
                            </h3>
                            <div
                              className="upk-salf-desc"
                              data-swiper-parallax-y="-200"
                              data-swiper-parallax-duration="1400"
                            >
                              {slide.description}
                            </div>
                            <div
                              className="upk-salf-button"
                              data-swiper-parallax-y="-300"
                              data-swiper-parallax-duration="1500"
                            >
                              {/* Button content yahan daal sakte ho */}
                            </div>
                          </div>
                        </SwiperSlide>
                      ))}
                    </Swiper>

                    <div className="upk-salf-nav-pag-wrap">
                      {/* Pagination chahiye to yahan daalo */}
                      {/* <div className="swiper-pagination"></div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* New Releases */}
            <div className="row">
              <div className="col-lg-12 px-0 px-md-3 mb-4">
                <div className="card-header mb-3">
                  <div className="header-title">
                    <h4 className="card-title text-capitalize">New releases</h4>
                  </div>
                  <div className="common-album position-relative d-lg-block d-none">
                    <div
                      className="swiper-button-prev"
                      onClick={() => sliderresRef.current?.slickPrev()}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={18}
                        height={19}
                        viewBox="0 0 18 19"
                        fill="none"
                      >
                        <path
                          d="M15.75 9.5C15.75 9.64918 15.6908 9.79226 15.5853 9.89775C15.4798 10.0032 15.3367 10.0625 15.1875 10.0625H4.17025L8.27298 14.1645C8.32525 14.2168 8.3667 14.2788 8.39499 14.3471C8.42327 14.4154 8.43783 14.4886 8.43783 14.5625C8.43783 14.6364 8.42327 14.7096 8.39499 14.7779C8.3667 14.8462 8.32525 14.9082 8.27298 14.9605C8.22072 15.0127 8.15868 15.0542 8.09039 15.0825C8.02211 15.1108 7.94893 15.1253 7.87502 15.1253C7.80111 15.1253 7.72792 15.1108 7.65964 15.0825C7.59135 15.0542 7.52931 15.0127 7.47705 14.9605L2.41455 9.89797C2.36225 9.84573 2.32076 9.78369 2.29245 9.7154C2.26414 9.64712 2.24957 9.57392 2.24957 9.5C2.24957 9.42608 2.26414 9.35288 2.29245 9.2846C2.32076 9.21631 2.36225 9.15427 2.41455 9.10203L7.47705 4.03953C7.58259 3.93398 7.72575 3.87469 7.87502 3.87469C8.02428 3.87469 8.16744 3.93398 8.27298 4.03953C8.37853 4.14508 8.43783 4.28823 8.43783 4.4375C8.43783 4.58677 8.37853 4.72992 8.27298 4.83547L4.17025 8.9375H15.1875C15.3367 8.9375 15.4798 8.99676 15.5853 9.10225C15.6908 9.20774 15.75 9.35082 15.75 9.5Z"
                          fill="#4A525F"
                        />
                      </svg>
                    </div>
                    <div
                      className="swiper-button-next"
                      onClick={() => sliderresRef.current?.slickNext()}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={18}
                        height={19}
                        viewBox="0 0 18 19"
                        fill="none"
                      >
                        <path
                          d="M15.5855 9.89797L10.523 14.9605C10.4174 15.066 10.2743 15.1253 10.125 15.1253C9.97573 15.1253 9.83258 15.066 9.72703 14.9605C9.62148 14.8549 9.56219 14.7118 9.56219 14.5625C9.56219 14.4132 9.62148 14.2701 9.72703 14.1645L13.8298 10.0625H2.8125C2.66332 10.0625 2.52024 10.0032 2.41475 9.89775C2.30926 9.79226 2.25 9.64918 2.25 9.5C2.25 9.35082 2.30926 9.20774 2.41475 9.10225C2.52024 8.99676 2.66332 8.9375 2.8125 8.9375H13.8298L9.72703 4.83547C9.62148 4.72992 9.56219 4.58677 9.56219 4.4375C9.56219 4.28823 9.62148 4.14508 9.72703 4.03953C9.83258 3.93398 9.97573 3.87469 10.125 3.87469C10.2743 3.87469 10.4174 3.93398 10.523 4.03953L15.5855 9.10203C15.6378 9.15427 15.6793 9.21631 15.7076 9.2846C15.7359 9.35288 15.7504 9.42608 15.7504 9.5C15.7504 9.57392 15.7359 9.64712 15.7076 9.7154C15.6793 9.78369 15.6378 9.84573 15.5855 9.89797Z"
                          fill="currentColor"
                        />
                      </svg>
                    </div>
                  </div>
                </div>

                {loadingPopular ? (
                  <div className="d-flex justify-content-center py-5">
                    <div className="spinner-border text-primary"></div>
                  </div>
                ) : popularPodcasts.length === 0 ? (
                  <>
                    <div className="d-flex justify-content-center py-5">
                      <span>No New Releases</span>
                    </div>
                  </>
                ) : (
                  <Slider
                    ref={sliderresRef}
                    {...settingss}
                    className="overflow-hidden"
                  >
                    {popularPodcasts.map((podcast) => (
                      <NewReleaseCard key={podcast._id} podcast={podcast} />
                    ))}
                  </Slider>
                )}
              </div>
            </div>

            {/* Featured Podcasts */}
            <div className="row mb-5">
              <div className="col-lg-12 px-0 px-md-3">
                <div className="card-header mb-3">
                  <div className="header-title">
                    <h4 className="card-title text-capitalize">
                      Featured Podcast
                    </h4>
                  </div>
                </div>
              </div>

              {loadingFeatured ? (
                <div className="d-flex justify-content-center py-5">
                  <div className="spinner-border text-primary"></div>
                </div>
              ) : featuredColumns.length === 0 ? (
                <>
                  <div className="d-flex justify-content-center py-5">
                    <span>No Featured Podcast</span>
                  </div>
                </>
              ) : (
                <div className="row">
                  {featuredColumns.map((columnPodcasts, columnIndex) => (
                    <div
                      key={columnIndex}
                      className="col-xl-3 col-lg-6 col-md-6 mb-3"
                    >
                      <ul className="p-0 list-unstyled mb-0">
                        {columnPodcasts.map((podcast, index) => (
                          <FeaturedPodcastItem
                            key={podcast._id}
                            podcast={podcast}
                            index={index}
                            totalCount={columnPodcasts.length}
                          />
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Genres */}
            <div className="row">
              <div className="col-lg-12 px-0 px-md-3 mb-5">
                <div className="card-header mb-3">
                  <div className="header-title">
                    <h4 className="card-title text-capitalize">
                      Top genres for you
                    </h4>
                  </div>
                  <div className="common-album position-relative d-lg-block d-none">
                    <div
                      className="swiper-button-prev"
                      onClick={() => slidergenRef.current?.slickPrev()}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={18}
                        height={19}
                        viewBox="0 0 18 19"
                        fill="none"
                      >
                        <path
                          d="M15.75 9.5C15.75 9.64918 15.6908 9.79226 15.5853 9.89775C15.4798 10.0032 15.3367 10.0625 15.1875 10.0625H4.17025L8.27298 14.1645C8.32525 14.2168 8.3667 14.2788 8.39499 14.3471C8.42327 14.4154 8.43783 14.4886 8.43783 14.5625C8.43783 14.6364 8.42327 14.7096 8.39499 14.7779C8.3667 14.8462 8.32525 14.9082 8.27298 14.9605C8.22072 15.0127 8.15868 15.0542 8.09039 15.0825C8.02211 15.1108 7.94893 15.1253 7.87502 15.1253C7.80111 15.1253 7.72792 15.1108 7.65964 15.0825C7.59135 15.0542 7.52931 15.0127 7.47705 14.9605L2.41455 9.89797C2.36225 9.84573 2.32076 9.78369 2.29245 9.7154C2.26414 9.64712 2.24957 9.57392 2.24957 9.5C2.24957 9.42608 2.26414 9.35288 2.29245 9.2846C2.32076 9.21631 2.36225 9.15427 2.41455 9.10203L7.47705 4.03953C7.58259 3.93398 7.72575 3.87469 7.87502 3.87469C8.02428 3.87469 8.16744 3.93398 8.27298 4.03953C8.37853 4.14508 8.43783 4.28823 8.43783 4.4375C8.43783 4.58677 8.37853 4.72992 8.27298 4.83547L4.17025 8.9375H15.1875C15.3367 8.9375 15.4798 8.99676 15.5853 9.10225C15.6908 9.20774 15.75 9.35082 15.75 9.5Z"
                          fill="#4A525F"
                        />
                      </svg>
                    </div>
                    <div
                      className="swiper-button-next"
                      onClick={() => slidergenRef.current?.slickNext()}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={18}
                        height={19}
                        viewBox="0 0 18 19"
                        fill="none"
                      >
                        <path
                          d="M15.5855 9.89797L10.523 14.9605C10.4174 15.066 10.2743 15.1253 10.125 15.1253C9.97573 15.1253 9.83258 15.066 9.72703 14.9605C9.62148 14.8549 9.56219 14.7118 9.56219 14.5625C9.56219 14.4132 9.62148 14.2701 9.72703 14.1645L13.8298 10.0625H2.8125C2.66332 10.0625 2.52024 10.0032 2.41475 9.89775C2.30926 9.79226 2.25 9.64918 2.25 9.5C2.25 9.35082 2.30926 9.20774 2.41475 9.10225C2.52024 8.99676 2.66332 8.9375 2.8125 8.9375H13.8298L9.72703 4.83547C9.62148 4.72992 9.56219 4.58677 9.56219 4.4375C9.56219 4.28823 9.62148 4.14508 9.72703 4.03953C9.83258 3.93398 9.97573 3.87469 10.125 3.87469C10.2743 3.87469 10.4174 3.93398 10.523 4.03953L15.5855 9.10203C15.6378 9.15427 15.6793 9.21631 15.7076 9.2846C15.7359 9.35288 15.7504 9.42608 15.7504 9.5C15.7504 9.57392 15.7359 9.64712 15.7076 9.7154C15.6793 9.78369 15.6378 9.84573 15.5855 9.89797Z"
                          fill="currentColor"
                        />
                      </svg>
                    </div>
                  </div>
                </div>

                {loadingGenres ? (
                  <div className="d-flex justify-content-center py-5">
                    <div className="spinner-border text-primary"></div>
                  </div>
                ) : genres.length === 0 ? (
                  <>
                    <div className="d-flex justify-content-center py-5">
                      <span>No Genres Yet</span>
                    </div>
                  </>
                ) : (
                  <Slider
                    ref={slidergenRef}
                    {...settings}
                    className="overflow-hidden"
                  >
                    {genres.map((genre) => (
                      <div key={genre._id} className="mb-3 px-2">
                        <Link
                          to={`podcasts/genre-podcasts`}
                          state={{
                            genreId: genre._id,
                            podcasts: genre.podcasts || [],
                            genreName: genre.genreName,
                          }}
                          className="text-decoration-none"
                        >
                          <img
                            src={
                              genre._id?.GenreImageUrl ||
                              `${process.env.PUBLIC_URL}/assets/images/dashboard/placeholder.png`
                            }
                            className="mb-3 img-fluid rounded-3"
                            alt={genre.genreName}
                            style={{ height: "220px", objectFit: "cover" }}
                          />
                          <div className="text-capitalize h5">
                            {genre.genreName}
                          </div>
                          <small className="text-muted">
                            {genre.podcasts
                              ? `${genre.podcasts.length} podcasts`
                              : "No podcasts"}
                          </small>
                        </Link>
                      </div>
                    ))}
                  </Slider>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
